import React from 'react';

import Alert from 'common/components/Alert';
import AutoScrollAlert from 'common/components/AutoScrollAlert';
import { HeadlineH7 } from 'common/components/Typography';
import { MessageType } from 'common/enums/Alert';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { ContactFormOrder } from '../../types';

interface OrderDrawerHeaderProps {
  orders: ContactFormOrder[];
  isLoading: boolean;
  hasFetchError?: boolean;
}

export const OrderDrawerHeader: React.FC<OrderDrawerHeaderProps> = ({
  orders,
  isLoading,
  hasFetchError,
}) => {
  const { t } = useLocalization();

  if (orders.length === 0 && !isLoading) {
    return (
      <Alert type={MessageType.Warning} mt={['sp_16', null, 'sp_20', 'sp_24']}>
        {t('h24_contact_user_has_no_orders')}
      </Alert>
    );
  }

  if (hasFetchError) {
    return (
      <AutoScrollAlert
        messageId={1}
        shouldScrollIntoView
        type={MessageType.Error}
        my={['sp_16', null, 'sp_20', 'sp_24']}
        message={t('h24_something_went_wrong')}
      />
    );
  }

  return <HeadlineH7 my={['sp_16', null, 'sp_20', 'sp_24']}>{t('h24_choose_order')}</HeadlineH7>;
};
